import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {TimelineLite, TweenLite} from "gsap";
import {TractorBeamScatterReelSymbol} from "../reelsymbol/TractorBeamScatterReelSymbol";
import {TractorBeamGameConfig} from "../TractorBeamGameConfig";
import {TractorBeamSoundConfig} from "../TractorBeamSoundConfig";
import {TractorBeamRandFeatureEvent} from "./TractorBeamRandomFeatureController";
import {TractorBeamStickySymbol} from "./TractorBeamStickySymbol";

export class TractorBeamRandomFeatureView extends BaseView {
    private _layer:ScalableLayer;
    private _hasPlayed:boolean = false;

    constructor(resourcesGroup:ResourcesGroupName) {
        super(resourcesGroup);
        this._layer = StageManager.getLayer(TractorBeamGameConfig.instance.LAYERS.SYMBOLS.name);
    }

    set hasPlayed(value:boolean) {
        this._hasPlayed = value;
    }

    protected initAnimations():void {
        this._layer.addChild(this);
    }

    public createRandomSymbol(reelId:number, symbols:StateReelSymbol[], isQuickStop:boolean, changeSpeed:boolean):void {
        let randomSymbolAnimTimeLine:TimelineLite = new TimelineLite({
            onComplete : () => {
                randomSymbolAnimTimeLine.pause();
                randomSymbolAnimTimeLine.kill();
            }
        });
        randomSymbolAnimTimeLine.addLabel('targetPointZero', 0);

        for(let i = 0; i < symbols.length; i++) {

            let randomSymbol:TractorBeamStickySymbol = new TractorBeamStickySymbol(symbols[i].symName);


            // TODO: Remove when S spine is in
            if(["L1", "L2", "L3", "L4", "S"].indexOf(symbols[i]!.symName) < 0) {
                randomSymbolAnimTimeLine.add(() => {
                    randomSymbol.position.x = Helper.getSymbolPositions(reelId, 1)[0];
                    randomSymbol.position.y = symbols[i].position.y;
                }, "targetPointZero");
                randomSymbolAnimTimeLine.to(randomSymbol.position, 0.1, {y : randomSymbol.position.y - 100}, "targetPointZero");
                randomSymbolAnimTimeLine.to(randomSymbol.position, 0.2, {y : -550}, "targetPointZero");

            }

            //if(symbols[i]!.symName === "S") {
            if(["L1", "L2", "L3", "L4", "S"].indexOf(symbols[i]!.symName) > -1) {
                const rand:number = Math.random() * 0.3;

                if(i === 0 && !this._hasPlayed) {
                    this._hasPlayed = true;
                    new TimelineLite().add(() => {
                        SlotGame.sound.playEffect(TractorBeamSoundConfig.instance.BEAM_UP);
                        (<TractorBeamScatterReelSymbol>symbols[i])!.hideSpineLayer();
                    });
                } else {
                    new TimelineLite().add(() => {
                        (<TractorBeamScatterReelSymbol>symbols[i])!.hideSpineLayer();
                    }, rand);
                }
            }

            if(i === symbols.length - 1 && changeSpeed) {
                randomSymbolAnimTimeLine.add(TweenLite.delayedCall(isQuickStop ? 1.8 : 1.8, this.resetReelSpeed, [], this), "targetPointZero");
            }
            symbols[i].currentStateAnimation!.alpha = 0;

            //this.addChild(randomSymbol);
        }
    }

    private resetReelSpeed():void {
        EventHandler.dispatchEvent(new GameEvent(TractorBeamRandFeatureEvent.RESET_REEL_SPEED, 0.04));
    }

    public clearRandomFeature(randomSymbolAnimTimeLine:TimelineLite, randomSymbol:TractorBeamStickySymbol):void {
        this.removeChild(randomSymbol);
        randomSymbolAnimTimeLine.pause();
        randomSymbolAnimTimeLine.kill();
    }

}
